var map = {
	"./decidim/avatar-multiuser.png": 47357,
	"./decidim/brands/facebook.svg": 49385,
	"./decidim/brands/google.svg": 14560,
	"./decidim/brands/twitter-x.svg": 27189,
	"./decidim/cc-badge.png": 56203,
	"./decidim/decidim-logo.svg": 91807,
	"./decidim/default-avatar.svg": 84115,
	"./decidim/gamification/badges/decidim_gamification_badges_followers.svg": 91385,
	"./decidim/icons.svg": 90754,
	"./decidim/pattern.png": 63617,
	"./decidim/placeholder-card-g.svg": 81550,
	"./decidim/placeholder-card-l.svg": 73701,
	"./decidim/placeholder.jpg": 70484,
	"./decidim/remixicon.symbol.svg": 34678,
	"./decidim/vendor/social-share-button/douban.svg": 42137,
	"./decidim/vendor/social-share-button/email.svg": 47034,
	"./decidim/vendor/social-share-button/facebook.svg": 75442,
	"./decidim/vendor/social-share-button/google_bookmark.svg": 46110,
	"./decidim/vendor/social-share-button/hacker_news.svg": 66906,
	"./decidim/vendor/social-share-button/linkedin.svg": 55464,
	"./decidim/vendor/social-share-button/odnoklassniki.svg": 20321,
	"./decidim/vendor/social-share-button/pinterest.svg": 36996,
	"./decidim/vendor/social-share-button/reddit.svg": 66846,
	"./decidim/vendor/social-share-button/telegram.svg": 67167,
	"./decidim/vendor/social-share-button/tumblr.svg": 42524,
	"./decidim/vendor/social-share-button/twitter.svg": 66191,
	"./decidim/vendor/social-share-button/vkontakte.svg": 56813,
	"./decidim/vendor/social-share-button/wechat.svg": 8528,
	"./decidim/vendor/social-share-button/whatsapp.svg": 96752,
	"./decidim/vendor/social-share-button/x.svg": 50778,
	"./decidim/vendor/social-share-button/xing.svg": 97486
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 70264;